module.exports = __webpack_public_path__ + "img/fi-roundup-150x150.aa861306.jpg";